<template>
  <div
    v-if="productIndustry.length"
    class="d-inline-block"
  >
    <div
      v-if="productIndustry == 'Medical' || productIndustry == 'Multiple'"
      class="badge-med-rec badge-medical"
      style="margin: 1px;"
    >
      Med
    </div>
    <div
      v-if="productIndustry == 'Recreational' || productIndustry == 'Multiple'"
      class="badge-med-rec badge-recreational"
      style="margin: 1px;"
    >
      Rec
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    product: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    productIndustry() {
      const { product } = this;
      let industry = '';

      let multipleIndustries = false;
      for (let i = 0; i < product.batches.length; i += 1) {
        if (product.batches[i].operation && product.batches[i].operation.state && product.batches[i].operation.state.display_med_rec_designations && product.batches[i].operation.industry) {
          if (industry == '' || product.batches[i].operation.industry == industry) {
            industry = product.batches[i].operation.industry;
          } else {
            multipleIndustries = true;
            break;
          }
        }
      }
      if (multipleIndustries) {
        industry = 'Multiple';
      }
      return industry;
    },
  },
  mounted() {},
  methods: {},

};
</script>
